import { useMutation } from "react-query";
import { sendNote } from "components/notes/lib/data";
import eventEmitter from "shared/events";

export const useSendNotes = () => {
    return useMutation(
        (items) => sendNote(items),
        {
            onSuccess: () => eventEmitter.emit("REFRESH_NOTES"),
        },
        {
            onError: () => notify.error("Task comment did not save!"),
        }
    );
};
